import CommentOutline from '@simplywallst/ui-core/icons/CommentOutline';
import { Button } from '@simplywallst/ui-core/next';
import { useTracking } from 'react-tracking';
type Props = {
  commentKey: string;
  commentCount: number;
  onCommentClick: () => void;
};

export const CommentNarrative = ({
  commentCount,
  commentKey,
  onCommentClick,
}: Props) => {
  const { trackEvent } = useTracking({
    type: 'track',
    subject: 'narrative',
    action: 'comment',
    commentKey,
  });

  return (
    <Button
      variant="outline"
      size="medium"
      onClick={() => {
        trackEvent();
        onCommentClick();
      }}
      className="px-x1"
      aria-label={`${commentCount} comments`}
    >
      <CommentOutline />
      {commentCount > 0 ? commentCount : null}
    </Button>
  );
};
